var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 1024",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75824 513.442C3.75824 231.944 231.554 3.74526 512.554 3.74526C793.554 3.74526 1021.35 231.944 1021.35 513.442C1021.35 794.939 793.554 1023.14 512.554 1023.14C231.554 1023.14 3.75824 794.939 3.75824 513.442Z",
    fill: "#90bdf9",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.892 652.808C262.887 652.808 282.084 646.013 300.294 641.156C326.264 634.229 351.976 629.181 378.67 625.863C409.57 622.023 440.725 620.31 471.695 617.124C496.353 614.588 520.996 611.344 545.676 609.114C594.89 604.666 644.361 602.63 693.638 598.919C729.706 596.202 764.964 590.793 800.581 585.082C808.522 583.809 816.7 582.55 824.753 582.169C827.436 582.042 831.358 579.923 832.811 582.169C834.678 585.057 832.48 589.122 831.346 592.364C829.098 598.788 823.251 603.346 819.626 609.114C804.564 633.072 794.822 659.958 781.537 684.85C753.656 737.09 719.069 784.542 671.664 821.03C656.929 832.371 641.207 842.924 624.052 850.159C616.302 853.428 607.957 855.08 599.88 857.442C591.354 859.935 582.919 862.807 574.243 864.724C556.017 868.751 538.716 870.606 520.039 869.822C497.134 868.859 476.257 861.961 454.848 854.529C445.297 851.213 435.526 848.419 426.281 844.333C381.915 824.73 347.153 793.594 312.746 760.587C299.328 747.714 285.47 735.213 273.192 721.262C262.897 709.564 252.5 697.825 243.892 684.85C240.223 679.319 237.929 672.974 234.37 667.373C232.049 663.718 229.593 660.013 226.313 657.177C223.841 655.04 220.453 654.264 217.523 652.808",
    fill: "#2e2626",
    fillOpacity: 0,
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.536 410.543C209.95 343.063 239.18 287.219 269.345 261.038C289.529 243.521 317.125 236.983 344.909 239.171C399.396 243.463 460.368 299.919 449.4 409.391",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.563 411.948C570.977 344.468 600.207 288.624 630.372 262.443C650.556 244.926 678.152 238.388 705.936 240.576C760.423 244.868 821.395 301.324 810.427 410.796",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.051 651.219C740.914 651.117 300.176 640.15 280.141 665.085C258.673 691.804 274.632 712.696 297.056 740.112C333.795 785.03 413.796 840.835 492.999 852.738C531.141 858.47 589.352 854.937 610.054 850.173C685.271 832.862 715.024 787.756 755.65 733.895C773.415 710.343 791.88 651.274 774.051 651.219Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/Smile.3929e02f84a0ca2da9d7f6b0f502cd90.svg";
export { ForwardRef as ReactComponent };